
import { defineComponent, computed, PropType } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'CatalogPagination',
  props: {
    currentPage: { type: Number as PropType<number>, required: true },
    totalPages: { type: Number as PropType<number>, required: true },
    maxPages: { type: Number as PropType<number>, default: 9 },
  },
  setup(props, { emit }) {
    const startPage = computed(() => {
      let start = 1
      if (props.totalPages <= props.maxPages) {
        start = 1
      } else {
        const maxBefore = Math.floor(props.maxPages / 2)
        const maxAfter = Math.ceil(props.maxPages / 2) - 1
        if (props.currentPage <= maxBefore) {
          start = 1
        } else if (props.currentPage + maxAfter >= props.totalPages) {
          start = props.totalPages - props.maxPages + 1
        } else {
          start = props.currentPage - maxBefore
        }
      }
      return start
    })

    const endPage = computed(() => {
      let end = props.totalPages
      if (props.totalPages <= props.maxPages) {
        end = props.totalPages
      } else {
        const maxBefore = Math.floor(props.maxPages / 2)
        const maxAfter = Math.ceil(props.maxPages / 2) - 1
        if (props.currentPage <= maxBefore) {
          end = props.maxPages
        } else if (props.currentPage + maxAfter >= props.totalPages) {
          end = props.totalPages
        } else {
          end = props.currentPage + maxAfter
        }
      }
      return end
    })

    const pages = computed(() => {
      const len = endPage.value + 1 - startPage.value
      return Array.from(Array(len).keys()).map((i) => startPage.value + i)
    })

    const emitPrev = () => emit('prev')
    const emitNext = () => emit('next')
    const emitGoto = (page: number) => emit('goto', page)

    return { pages, emitPrev, emitNext, emitGoto }
  },
})
